import { SCAttributes } from "../common/generic/generic-sc-attributes";
import { clientVision, liquidyInvest, snapshotKpi } from "./constants";
import { IProps } from "./type";

const DDL_VALUES_BY_ATTRIBUTE: { [key: string]: any } = {};
const DDL_DEFAULT_VAL_BY_ATTRIBUTE: { [key: string]: any } = {};
DDL_VALUES_BY_ATTRIBUTE[clientVision.CLIENT_VISION] = [
  { label: "Commercial client", value: "1" },
  { label: "CORI client", value: "2" },
];
DDL_VALUES_BY_ATTRIBUTE[SCAttributes.SC_MARK_IS_ELEC] = [
  { label: "Voice & Electronic", value: "" },
  { label: "Electronic", value: "Y" },
  { label: "Voice", value: "N" },
];

DDL_VALUES_BY_ATTRIBUTE[SCAttributes.SC_MARK_SUB_STEP_LEVEL] = [
  { label: "level 4.1", value: "4.1" },
  { label: "level 4.3", value: "4.3" },
  { label: "level 4.3.1", value: "4.3.1" },
];

DDL_VALUES_BY_ATTRIBUTE[SCAttributes.SC_MARK_STEP_GROUP] = [
  { label: "level 1", value: "1" },
  { label: "level 4", value: "4" },
];
DDL_VALUES_BY_ATTRIBUTE[snapshotKpi.INITIAL_KPI] = DDL_VALUES_BY_ATTRIBUTE[
  snapshotKpi.FINAL_KPI
] = [
  { label: "NBI YTD", value: "nbi_ytd" },
  { label: "NBI full Year", value: "nbi_fy" },
  { label: "Forecast NBI H1", value: "nbi_forcast_h1" },
  { label: "Forecast NBI YR1", value: "nbi_forcast_y1" },
];
DDL_VALUES_BY_ATTRIBUTE[liquidyInvest.LIS] = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
  { label: "All", value: "" },
];

DDL_DEFAULT_VAL_BY_ATTRIBUTE[clientVision.CLIENT_VISION] = "1";
DDL_DEFAULT_VAL_BY_ATTRIBUTE[SCAttributes.SC_MARK_IS_ELEC] = "";
DDL_DEFAULT_VAL_BY_ATTRIBUTE[SCAttributes.SC_MARK_STEP_GROUP] = "4";

DDL_DEFAULT_VAL_BY_ATTRIBUTE[
  snapshotKpi.INITIAL_KPI
] = DDL_DEFAULT_VAL_BY_ATTRIBUTE[snapshotKpi.FINAL_KPI] = "nbi_ytd";
DDL_DEFAULT_VAL_BY_ATTRIBUTE[liquidyInvest.LIS] = "";

export function getDdlValuesByAttribute(attribute: string): any[] {
  return DDL_VALUES_BY_ATTRIBUTE[attribute]
    ? DDL_VALUES_BY_ATTRIBUTE[attribute]
    : [];
}

export function getDefaultValueByAttribute(
  intraprops: IProps,
  attribute: string
): string {
  const tag =
    intraprops.userSelection &&
    intraprops.userSelection[attribute] &&
    intraprops.userSelection[attribute].length === 1
      ? intraprops.userSelection[attribute][0]
      : DDL_DEFAULT_VAL_BY_ATTRIBUTE[attribute];
  return tag;
}
